module.exports = __webpack_public_path__ + "static/media/Homecoming Queen.74141e1a.svg";